export default Object.freeze({
    DEFAULT_TITLE: 'Loyal Solutions – We believe in loyalty',
});
